import React, {useEffect, useState} from 'react';
import Web3 from "web3";
import USDC from "../../abis/USDC.json"
import PBT from "../../abis/PBT.json"
import { amountSToB, reFormatHexAddress, weiToEther} from '../../helpers/utilities';
import configData from "../../config.json";
import styled from 'styled-components';
import ConditionalToken from "../../abis/ConditionalTokens.json"
import RealityEth from "../../abis/RealityEthV3_0.json"
import FixedProductMarketMakerFactory from "../../abis/FixedProductMarketMakerFactory.json"
import Button from '../UI/Button/Button';
import { getChainBaseUrl} from '../../helpers/web3';

import { useTranslation } from 'react-i18next';

export const Web3Connect = (props) => {
    const { t } = useTranslation();
    const [installMetamask, setInstallMetamask] = useState(false);
    const {globalState, setGlobalState, appearance = 'default'} = props;
    const [metamaskConnected, setMetamaskConnect] = useState(false);
    const [currentAccount, setCurrentAccount] = useState('');
    const [usdBalance, setUsdBalance] = useState(0);
    const [pbtBalance, setPbtBalance] = useState(0);
    const [chainId, setChainId] = useState(0);
    const loadContracts = async (web3, chainId=0) => {
        // if(globalState.currentAddress!=""){
            let collateralToken = null;

            if(chainId === configData.OTHER_PAGES_CHAIN_ID)
                collateralToken = await new web3.eth.Contract(USDC, configData.addresses.collateralToken);

            let pbtToken = null;

            if(chainId === configData.DAO_PAGES_CHAIN_ID)
                pbtToken = await new web3.eth.Contract(PBT, configData.addresses.PbtTokenContract);

            const conditionalToken = await new web3.eth.Contract(ConditionalToken.abi, configData.addresses.conditionalToken);
            const realityEth = await new web3.eth.Contract(RealityEth, configData.addresses.realityEth);
            // const fixedProductMarketMakerFactory = await new web3.eth.Contract(FixedProductMarketMakerFactory.abi, configData.addresses.fixedProductMarketMakerFactory);
            const contracts =  {
                collateralToken: collateralToken, 
                conditionalToken: conditionalToken,
                pbtToken: pbtToken,
                realityEth
                // fixedProductMarketMaker: fixedProductMarketMakerFactory
            };
            return contracts;
        // }else{
        //     alert('does not enter')
        // }
    }

    const afterConnect = async (web3) => {
        const accounts = await web3.eth.getAccounts();
        
        if(accounts.length > 0){
            try{            
                let firstAccount = accounts[0];
                // registerProviderEvents();
                
                const chainId = await web3.eth.getChainId();
                const contracts = await loadContracts(web3, chainId);

                let collateralBalanceSmallestUnit = 0;
                let collateralBalance = 0
                if(chainId===configData.OTHER_PAGES_CHAIN_ID){
                    const collateralToken = await new web3.eth.Contract(USDC, configData.addresses.collateralToken);
                    collateralBalanceSmallestUnit = await collateralToken.methods.balanceOf(firstAccount).call({from: firstAccount})
                    collateralBalance = amountSToB(collateralBalanceSmallestUnit)
                }

                let pbtBalanceSmallestUnit = 0;
                let pbtBalance = 0
                if(chainId===configData.DAO_PAGES_CHAIN_ID){
                    const pbtToken = await new web3.eth.Contract(PBT, configData.addresses.PbtTokenContract);
                    pbtBalanceSmallestUnit = await pbtToken.methods.balanceOf(firstAccount).call({from: firstAccount})
                    pbtBalance = weiToEther(pbtBalanceSmallestUnit)
                }
                
                //set the balance of current account
                const weiBalance = await web3.eth.getBalance(firstAccount)
                let ethBal = await web3.utils.fromWei(weiBalance);
                let metamaskConnected = true;
                setMetamaskConnect(true);
                setCurrentAccount(firstAccount.toLowerCase());
                setUsdBalance(collateralBalance)
                setPbtBalance(pbtBalance)
                setChainId(chainId);
                
                // const contracts = await loadContracts(web3);
                setGlobalState({
                    ...globalState, 
                    collateralBalance,
                    collateralBalanceSmallestUnit,
                    currentAddress: firstAccount.toLowerCase(),
                    web3: web3,
                    balance: ethBal,
                    chainId,
                    accounts,
                    metamaskConnected,
                    loadedContracts: {
                        ...contracts
                    }
                });
                // const signature = await signTermsAndConditions();
            }catch(e){
                console.log(e)
            }
        }else{
            const contracts = await loadContracts(web3);
            setGlobalState({
                ...globalState, 
                loadedContracts: {
                    ...contracts
                }
            });
        }
    }


    const registerProviderEvents = () => {
        window.ethereum.on('accountsChanged', (accounts) => {
            // Handle the new accounts, or lack thereof.
            // "accounts" will always be an array, but it can be empty.
            window.location.reload();
        });
        
        window.ethereum.on('chainChanged', (chainId) => {
            window.location.reload();
        });

        window.ethereum.on('disconnect', (error) => {
            if(globalState.metamaskConnected === true)
                window.location.reload();
        });
    }

    const connect = async (e) => {
        if (window.ethereum && window.ethereum.isMetaMask) {
            const web3 = new Web3(window.ethereum);
            try {
                // Request account access if needed
                await window.ethereum
                .request({ method: 'eth_requestAccounts', params: [] })
                await afterConnect(web3)
            } catch (error) {
                console.log(error)
            }
        }
        // return false;
    }

    useEffect(() => {
        if (typeof window.ethereum === 'undefined' || !window.ethereum.isMetaMask) {
            setInstallMetamask(true);
            setGlobalState({...globalState, installMetamask: true})
        }else{
            registerProviderEvents();

            const web3 = new Web3(window.ethereum);
            afterConnect(web3)
        }
    }, [globalState.chainId, globalState.collateralBalance, globalState.pbtBalance]);
  
    return (
        <WalletWrap>
            {installMetamask && (
              <ActionButton
                as="a"
                rel="noopener noreferrer"
                target="_blank"
                href="https://metamask.io/download.html"
                fullWidth={appearance === 'staking'}
              >
                Install Metamask
              </ActionButton>
            )}
            {!installMetamask && metamaskConnected!==true && (
              <ActionButton
                type="submit"
                onClick={connect}
                fullWidth={appearance === 'staking'}
              >
                {t('connect_wallet')}
              </ActionButton>
            )}
            {metamaskConnected===true && 
                <ConnectedRow>
                    {chainId === configData.OTHER_PAGES_CHAIN_ID && (
                      <BalancePill
                        href={getChainBaseUrl(globalState.chainId) + `/address/${configData.addresses.collateralToken}`}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <BalanceLabel>USDC</BalanceLabel>
                        <BalanceValue>{usdBalance}</BalanceValue>
                      </BalancePill>
                    )}
                    {chainId === configData.DAO_PAGES_CHAIN_ID && (
                      <BalancePill
                        href={getChainBaseUrl(globalState.chainId) + `/address/${configData.addresses.PbtTokenContract}`}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <BalanceLabel>PBT</BalanceLabel>
                        <BalanceValue>{pbtBalance}</BalanceValue>
                      </BalancePill>
                    )}
                    <WalletButton type="button" onClick={connect}>
                      {reFormatHexAddress(currentAccount)}
                    </WalletButton>
                </ConnectedRow>
            }
        </WalletWrap>
    );
};

const gradientPrimary = 'linear-gradient(135deg, hsl(263 70% 60%), hsl(190 95% 45%))';

const WalletWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const ConnectedRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const ActionButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  white-space: nowrap;
  height: 40px;
  padding: 8px 16px;
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1.25rem;
  font-family: inherit;
  color: hsl(210 40% 98%);
  background-color: transparent;
  background-image: ${gradientPrimary};
  border: none;
  border-radius: 10px;
  cursor: pointer;
  box-shadow: none;
  text-decoration: none;
  transition: color 0.2s ease, background-color 0.2s ease, opacity 0.2s ease, box-shadow 0.2s ease;
  width: ${({ fullWidth }) => (fullWidth ? '100%' : 'auto')};

  &:hover {
    opacity: 0.9;
  }

  &:focus {
    outline: none;
  }

  &:focus-visible {
    outline: none;
    box-shadow:
      0 0 0 2px hsl(222 47% 6%),
      0 0 0 4px hsl(263 70% 60%);
  }

  &:disabled {
    pointer-events: none;
    opacity: 0.5;
  }
`;

const WalletButton = styled(ActionButton)`
  color: hsl(210 40% 98%);
  font-weight: 500;
`;

const BalancePill = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  border-radius: 12px;
  background: #0f172a;
  border: 1px solid #1f2937;
  color: #e5e7eb;
  text-decoration: none;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.04);
`;

const BalanceLabel = styled.span`
  font-size: 12px;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  color: #9ca3af;
`;

const BalanceValue = styled.span`
  font-size: 14px;
  font-weight: 700;
  color: #e5e7eb;
`;
